/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Statistics_Job_ColumnInputs */

const en_admin_statistics_job_column = /** @type {(inputs: Admin_Statistics_Job_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job position`)
};

const de_admin_statistics_job_column = /** @type {(inputs: Admin_Statistics_Job_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stelle`)
};

/**
* | output |
* | --- |
* | "Job position" |
*
* @param {Admin_Statistics_Job_ColumnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_statistics_job_column = /** @type {((inputs?: Admin_Statistics_Job_ColumnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Statistics_Job_ColumnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_statistics_job_column(inputs)
	return en_admin_statistics_job_column(inputs)
});